const isMe = ()=>{
    // set when needed with command: document.cookie = "me=true";
    if(document.cookie.includes("me=true")) return true;
    else return false;
}
const isDev = ()=>{
    return ( window.location.hostname.includes("dev.") );
}
const isLocal = ()=>{
    return (
        window.location.hostname === "localhost" ||
        window.location.hostname === "127.0.0.1" ||
        window.location.hostname === "0.0.0.0"
    );
}
const isEditor = ()=>{
    return window.location.pathname.includes('maker');
}
const checkUrlExists = (url) => {
    return new Promise((resolve) => {
        fetch(url, { method: 'HEAD' })
            .then((response) => {
                // If the HTTP status is in the 200-299 range, the file exists
                resolve(response.ok);
            })
            .catch(() => {
                // If there's any error (like network issues), resolve to false
                resolve(false);
            });
    });
};
const getParam = (name)=>{
    return new URLSearchParams(window.location.search).get(name)
}
const setScroll = (flag)=>{
    var state = 'hidden';
    if(flag) state = 'auto';
    document.body.style.overflow = state;
}
const isEmail = (email)=>{
    if( /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email) ) return true;
    else return false;
}
const sleep = (sec)=>{
    return new Promise( (resolve, reject)=>setTimeout(resolve,sec*1000) );
}
const loadScript = (path)=>{
    return new Promise((resolve,reject)=>{
        const script  = document.createElement("script");
        script.onload = ()=>{
            resolve();
        }
        script.onerror = (err)=>{
            reject(err);
        }
        script.src = path;
        document.head.appendChild(script);
    })
}
const setVidPrevMade = (flag)=>{
    vidPrevMade = flag;
}
const getVidPrevMade = ()=>{
    return vidPrevMade;
}
const loadGtag = ()=>{
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-PGNBVK7');
}
const pushData = (eventName)=>{
    if(window.dataLayer){
        window.dataLayer.push({'event': eventName})
        console.log("Data layer event pushed: "+eventName);
    }
    else console.log("No Data Layer."); 
}

let vidPrevMade;
const utils = {isMe, isDev, isLocal, isEditor, getParam, setScroll, isEmail, sleep, loadScript, setVidPrevMade, getVidPrevMade, loadGtag, pushData, checkUrlExists}

export default utils;